import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export default (function (theme) {
  return {
    root: {
      position: 'relative',
      fontFamily: 'inherit'
    },
    menu: {
      outline: 'none',
      marginBottom: '0',
      paddingLeft: '0',
      listStyle: 'none',
      '& .rc-menu-submenu-title': {
        paddingBottom: '8px',
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        userSelect: 'none',
        '& span': {
          marginRight: '8px'
        }
      }
    },
    subMenu: {
      position: 'relative',
      width: function width(props) {
        return props.popupSize;
      },
      minWidth: 'auto !important',
      overflow: 'hidden',
      paddingTop: '8px',
      paddingBottom: '8px',
      backgroundColor: theme.colors.neutralBase,
      boxShadow: theme.effects.boxShadow,
      borderRadius: 4,
      '& .rc-menu-sub': {
        padding: '0',
        margin: '0',
        minWidth: 'auto !important'
      },
      '&.rc-menu-submenu-hidden': {
        display: 'none'
      }
    },
    menuItem: _objectSpread(_objectSpread({
      padding: '8px 12px',
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'row-reverse',
      justifyContent: 'flex-end',
      listStyle: 'none',
      userSelect: 'none'
    }, theme.typography.subtitle), {}, {
      '& span': {
        marginRight: '10px'
      }
    }),
    menuItemContent: {
      flex: 1
    },
    clickable: {
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: theme.colors.neutral300
      }
    }
  };
});